<template>
  <button
    class="button"
    :disabled="disabled"
    @click="handleButton"
    :style="{
      'background-color': back_color,
      color: text_color,
      borderRadius: border_radius,
      borderWidth: border ? '1px' : '0',
      borderStyle: border ? 'solid' : 'none',
      borderColor: border_color,
      fontSize: font_size,
      fontFamily: font_family,
      height: height,
      fontWeight: font_weight
    }"
  >
    {{ button_text }}
  </button>
</template>

<script>
export default {
  props: {
    back_color: {
      type: String,
      default: "#00a656"
    },
    text_color: {
      type: String,
      default: "#ffffff"
    },
    button_text: {
      type: String,
      default: "button"
    },
    border_radius: {
      type: String,
      default: "4px"
    },
    border: {
      type: Boolean,
      default: true
    },
    border_color: {
      type: String,
      default: "#000000"
    },
    font_size: {
      type: String,
      default: "16px"
    },
    font_family: {
      type: String,
      default: "Arial, sans-serif"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: "50px"
    },
    font_weight: {
      type: String,
      default: "normal"
    }
  },
  methods: {
    handleButton() {
      this.$emit("handleClick");
    }
  }
};
</script>

<style lang="css" scoped>
.button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BaseBtnDetail.vue